import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";


@Injectable()
export class IngressService {

  public constructor(
    private http: HttpClient
  ) {
  }

  public async getFreePort(server: string): Promise<number> {
    const url = `${server}/ingress/api/port`;

    return new Promise<number>((resolve, reject) => {
      this.http.get(url)
        .subscribe(
          (res: {port: number}) => resolve(res.port),
          error => reject(error));
    });
  }
  public async addService(server: string, domain: string, targetPort: number): Promise<void> {
    const targetHost = 'host.docker.internal';
    const url = `${server}/ingress/api/mapping`;

    const body = {
      domain,
      targetHost,
      targetPort
    };

    return new Promise<void>((resolve, reject) => {
      this.http.put(url, body)
        .subscribe(
          () => resolve(),
          error => reject(error));
    });
  }
}
